export default __webpack_public_path__ + "static/media/tube-2-h-en.1b474d67.svg";